<template>
    <v-layout fill-height>
        <v-flex v-if="showDialog">
            <v-dialog
                    v-model="showDialog"
                    transition="slide-x-transition"
                    persistent
                    fullscreen
            >
                <v-card class="fill-height">
                    <v-layout column fill-height>
                        <v-flex shrink>
                            <v-card-title class="py-2 pr-2 primary">
                                <span class="title font-weight-regular white--text">Mail Viewer</span>
                                <v-spacer></v-spacer>

                                <div style="display: inline"><slot></slot></div>

                                <v-btn flat icon color="white" class="pa-0 ma-0" @click="printPreview">
                                    <v-icon>print</v-icon>
                                </v-btn>
                              
                                <div v-show="false" ref="printLink"></div>

                                <v-btn flat icon color="white" class="pa-0 ma-0" @click="$emit('dismiss', true)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-divider></v-divider>
                        </v-flex>
                        <v-flex shrink>
                            <app-mailbox-message-header
                                    :user-info="userInfo"
                                    :message="mail"
                            />
                        </v-flex>
                        <v-flex xs12 class="text-xs-center pa-4" v-if="loadingHtml">
                            <v-progress-circular
                                    :size="40"
                                    :width="5"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                        <v-flex v-else xs12 class="scroll" style="overflow-y: hidden; overflow-x: auto">
                            <!--Message Body-->
                            <iframe
                                    :key="iframeKey"
                                    :src="htmlSrc"
                                    ref="mailView"
                                    style="width: 100%;"
                                    @load="iframeReset"
                                    @error="handleIframeError"
                                    frameborder="0"
                                    class="fill-height"
                                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                            >
                            </iframe>
                        </v-flex>
                        <v-flex shrink>
                            <!--Attachments-->
                            <template v-if="mail.attachments != null && mail.attachments != '' && mail.attachments != '[]'">
                                    <v-chip
                                            v-for="(attachment, i) in viewAttachemnts" :key="'att' + i"
                                            label
                                            outline
                                            color="primary"
                                            small
                                    >
                                        <v-layout row>
                                            <v-flex class="pr-1" shrink v-show="['pdf', 'PDF'].includes(attachment.attName.split('.').pop())">
                                                <doc-view
                                                    :url="`${baseServerAddress}mailstore/${userInfo.entityID}/${mailPath}/${attachment.attName}`"
                                                >
                                                    <v-tooltip top>
                                                        <v-icon
                                                            style="cursor: pointer"
                                                            small
                                                            slot="activator"
                                                            color="primary"
                                                            class="ma-0"
                                                        >
                                                            visibility
                                                        </v-icon>
                                                        <span>View Attachment</span>
                                                    </v-tooltip>
                                                </doc-view>
                                            </v-flex>
                                            <v-flex class="pr-1" shrink>
                                                <v-tooltip top>
                                                    <v-icon
                                                            style="cursor: pointer"
                                                            small
                                                            slot="activator"
                                                            color="primary"
                                                            class="ma-0"
                                                            @click="runPreviewAttachment(mailPath, attachment.attName, true)"
                                                    >
                                                        attachment
                                                    </v-icon>
                                                    <span>Download Attachment</span>
                                                </v-tooltip>
                                            </v-flex>
                                        </v-layout>

                                        <a v-if="attachment.attName.length > 20"
                                           style="text-decoration: none" class="text--primary"
                                            :href="serverAddress + '/mailstore/' + userInfo.entityID + '/' + mailPath + '/' + attachment.attName"
                                           target="_blank">
                                            <span class="primary--text">{{ attachment.attName.substring(0,20) + '...' }} </span>
                                        </a>
                                        <a v-else style="text-decoration: none"
                                            :href="serverAddress + '/mailstore/' + userInfo.entityID + '/' + mailPath + '/' + attachment.attName"
                                            target="_blank">
                                            <span class="primary--text">{{ attachment.attName }}</span>
                                        </a>
                                    </v-chip>

                                <v-chip
                                    v-if="!showEmbedded && viewAttachemnts.length < mail.attachments.length"
                                    label
                                    outline
                                    color="secondary"
                                    small
                                    @click="showEmbedded = true"
                                    style="cursor: pointer"
                                >
                                    <strong>+{{this.mail.attachments.length - viewAttachemnts.length}} More</strong>
                                </v-chip>

                            </template>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>

    import { codeBaseMixin} from "../../codeBaseMixin";
    import MailboxMessageHeader from "../../Mail/Gmail/components/MailboxMessageHeader.vue";
    import tokenMan from '../../tokenManSite'
    import DocView from "@/DocView/DocView";

    export default {
        mixins: [ codeBaseMixin ],
        components: {
            DocView,
            appMailboxMessageHeader: MailboxMessageHeader
        },
        props: {
            userInfo: Object,
            mail: Object,
            showDialog: Boolean
        },
        data() {
            return {
                messageHtml: "",
                mailPath: "",
                loadingHtml: false,
                showEmbedded: false,
                iframeKey: 0,
                iframeLoadRetries: 0
            }
        },
        methods: {
            printPreview() {
                window.open(`${this.baseServerAddress}mailView?entityID=${this.userInfo.entityID}&mailID=${this.mail.mailDBID}&token=${tokenMan.token()}`, '_blank')
                this.$emit('dismiss', true)
            },


            runPreviewAttachment(mailDownloadPath, attName, download) {
                let downloadAddress = '';
                downloadAddress = this.baseServerAddress + 'mailstore/' + this.userInfo.entityID + '/' + mailDownloadPath + '/' + attName;
                let win = window.open(downloadAddress, '_blank');
            },

            iframeReset(event) {
                try {
                    let iframe = this.$refs.mailView;
                    if (!iframe) return;

                    // Check if iframe content is accessible
                    let iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

                    if (!iframeDoc) {
                        // If content not accessible, retry after delay
                        if (this.iframeLoadRetries < 3) {
                            this.iframeLoadRetries++;
                            setTimeout(() => this.iframeReset(event), 500);
                        }
                        return;
                    }

                    // Check if the document has a body
                    if (!iframeDoc.body || iframeDoc.body.innerHTML.trim() === '') {
                        // If body is empty, force reload the iframe
                        if (this.iframeLoadRetries < 3) {
                            this.iframeLoadRetries++;
                            // Force iframe reload by changing key
                            this.iframeKey++;
                            return;
                        }
                    }

                    // Reset retry counter on successful load
                    this.iframeLoadRetries = 0;

                    // Only add styles if head exists
                    if (iframeDoc.head) {
                        // Check if style already exists
                        let existingStyle = iframeDoc.head.querySelector('style[data-mail-viewer]');
                        if (!existingStyle) {
                            let style = iframeDoc.createElement('style');
                            style.setAttribute('data-mail-viewer', 'true');
                            style.type = 'text/css';
                            style.appendChild(iframeDoc.createTextNode(`
                                body {
                                    font-family: sans-serif;
                                }
                                body::-webkit-scrollbar-track {
                                    background-color: #ededed;
                                }
                                body::-webkit-scrollbar {
                                    width: 8px;
                                    height: 8px;
                                    background-color: #F5F5F5;
                                }
                                body::-webkit-scrollbar-thumb {
                                    background-color: #00897B;
                                }`));
                            iframeDoc.head.appendChild(style);
                        }
                    }
                } catch (error) {
                    console.error('Error in iframeReset:', error);
                    // Retry on error
                    if (this.iframeLoadRetries < 3) {
                        this.iframeLoadRetries++;
                        setTimeout(() => this.iframeReset(event), 500);
                    }
                }
            },

            handleIframeError() {
                console.error('Iframe loading error');
                // Force reload on error
                if (this.iframeLoadRetries < 3) {
                    this.iframeLoadRetries++;
                    this.iframeKey++;
                }
            },

            forceReloadIframe() {
                // Manual reload method if needed
                this.iframeLoadRetries = 0;
                this.iframeKey++;
            },

        },
        watch: {
            mail: {
                handler(newMail) {
                    // Reset iframe state when mail changes
                    if (newMail) {
                        this.iframeLoadRetries = 0;
                        this.loadingHtml = true;

                        // Small delay to ensure DOM updates
                        this.$nextTick(() => {
                            this.loadingHtml = false;
                        });
                    }
                },
                deep: true
            },
            showDialog(newVal) {
                // Reset iframe when dialog opens
                if (newVal) {
                    this.iframeLoadRetries = 0;
                }
            }
        },
        computed: {
            viewAttachemnts() {
                return this.mail.attachments.filter(obj => this.showEmbedded ? true : obj.type !== 'embedded')
            },

            htmlSrc() {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.mailPath = this.mail.fk_gmail_group_mailbox_folder == 0 ? (this.mail?.fk_import_user + '-' + this.mail?.mailID) : (this.mail?.fk_gmail_group_mailbox_folder + '-' + this.mail?.mailID);

                let sRequ = this.serverAddress + '/mailstore/' + this.userInfo.entityID + '/' + this.mailPath + '/' + this.mailPath + '.html';

                return sRequ
            }
        }
    }
</script>

<style scoped>

</style>
